/* HoverIntent config options */
 
$(document).ready(function() {
	function showDropdown(){
		$(this).addClass('active');
		$(this).children('.dropdown').fadeIn(500);
	}
	function hideDropdown(){
		$(this).removeClass('active');
		$(this).children('.dropdown').fadeOut(250);
	}
	var dropdownConfig = {
		sensitivity: 4,
		over: showDropdown,
		out: hideDropdown,
		timeout: 250
	};
	$('.dropdown-parent').hoverIntent(dropdownConfig);
});